// PrescriptionAPI.js
import axios from "axios";

export const generatePrescriptionPdf = (id, branch, token, branchData, address) => {
  return axios.post(
    `${process.env.REACT_APP_CRI_API}prescript/pdf/${id}?branch=${branch}`,
    { branchData, address },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};